import React, { FC, useState } from 'react';
import notAvailablePic from '../../../../../images/missing.png';
import { useServiceFilePreview } from './hooks/useServiceFilesPreview';
import '@syncfusion/ej2-layouts/styles/material.css';

interface ImageCardProps {
  absolutePath: string;
  imageName: string;
  zoomLevel: number;
}

const ImageCard: FC<ImageCardProps> = ({ absolutePath, imageName, zoomLevel }) => {
  const [imageBase64, setImageBase64] = useState<string | null>(null);
  const isImage = absolutePath
    ? absolutePath.toLowerCase().split('.').pop()?.match(/^(png|jpg|jpeg|gif)$/)
    : false;

  useServiceFilePreview(setImageBase64, absolutePath);

  return (
    <div
      className="e-card"
      id="basic"
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden',
      }}
    >
      {/* Header mit optionalem Titel oder Tooltip */}
      <div className="e-card-header" style={{ padding: '8px' }}>
        <div className="e-card-header-caption">
          {zoomLevel >= 0.6 ? (
            <div
              className="e-card-header-title"
              style={{
                fontSize: '0.9rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
              }}
            >
              {imageName}
            </div>
          ) : (
            <div
              className="e-card-header-title"
              title={imageName}
              style={{
                fontSize: '0.9rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                opacity: 0, // vollständig ausblenden
              }}
            >
              {imageName}
            </div>
          )}
        </div>
      </div>

      {/* Bildinhalt */}
      <div
        className="e-card-content"
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '8px',
        }}
      >
        <img
          src={isImage ? imageBase64 ?? notAvailablePic : notAvailablePic}
          alt={imageName}
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </div>
    </div>
  );
};

export default ImageCard;
